var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const cleanCurrency = (value) => {
    const valueStr = typeof value === 'number' ? value.toString() : value;
    return typeof valueStr === 'string' ? valueStr.replace(/[^0-9,-.]+/g, '') : '';
};
const initFormatter = (_a = {}) => {
    var { style = 'currency' } = _a, props = __rest(_a, ["style"]);
    return new Intl.NumberFormat('es-cl', Object.assign(Object.assign({ currency: 'CLP', minimumFractionDigits: 0, maximumFractionDigits: 0 }, props), { style }));
};
export const formatCurrency = (value, { isDebt = false, clearZero = true, currencyStyle = 'currency', } = {}) => {
    const cleanValue = cleanCurrency(value);
    if (cleanValue === '0' && clearZero)
        return '-';
    if (cleanValue.length < 1)
        return cleanValue;
    const formatter = initFormatter({ style: currencyStyle });
    const cleanNumber = parseFloat(cleanValue) * (isDebt ? -1 : 1);
    return formatter.format(cleanNumber);
};
export const formatNumberAsCurrency = (number) => formatCurrency(number, { currencyStyle: 'decimal' });
//# sourceMappingURL=formatCurrency.js.map